export default __webpack_public_path__ + "static/media/toll_road.7829eda3.webp";